export const BANNER_PADRAO = Object.freeze({
    imagens: [
        {
            src: 'https://picsum.photos/800/400?random=1',
            alt: 'Banner 1',
            titulo: 'Título do Banner 1',
            descricao: 'Descrição do primeiro banner',
        },
        {
            src: 'https://picsum.photos/800/400?random=2',
            alt: 'Banner 2',
            titulo: 'Título do Banner 2',
            descricao: 'Descrição do segundo banner',
        },
    ],
    altura: '400px',
    autoPlay: true,
    intervalo: 5000,
    mostrarControles: true,
    mostrarIndicadores: true,
    estilos: {
        container: {
            borderRadius: '8px',
            boxShadow: 'none',
        },
        imagem: {
            borderRadius: '8px',
            objectFit: 'cover',
        },
        seta: {
            background: 'rgba(0, 0, 0, 0.3)',
            color: '#fff',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            fontSize: '22px',
        },
        indicador: {
            ativo: {
                background: '#0f97c7',
            },
            inativo: {
                background: '#bbb',
            },
            width: '10px',
            height: '10px',
            borderRadius: '50%',
        },
    },
});

export const VIDEO_PADRAO = Object.freeze({
    largura: '560',
    altura: '315',
    estilos: {
        container: { borderRadius: '8px', background: '#000', boxShadow: 'none' },
        player: { width: '100%', height: '360px' },
    },
});

export const MAPA_PADRAO = Object.freeze({
    iframe: '<iframe src="https://www.google.com/maps/embed?pb=..." width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
    estilos: {
        container: { borderRadius: '8px', border: '1px solid #eee', boxShadow: 'none', height: '300px' },
    },
});

export const FORMULARIO_PADRAO = Object.freeze({
    campos: [
        {
            nome: 'campo1',
            placeholder: 'Configurado na Próxima etapa',
            tipo: 'text',
            valor: '',
            estilos: {
                container: {
                    marginBottom: '16px',
                },
                input: {
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    color: '#1e88a8',
                    textAlign: 'center',
                    padding: '18px 0',
                    fontSize: '1.1em',
                    background: '#fff',
                    width: '100%',
                },
            },
        },
        {
            nome: 'campo2',
            placeholder: 'Configurado na Próxima etapa',
            tipo: 'text',
            valor: '',
            estilos: {
                container: {
                    marginBottom: '16px',
                },
                input: {
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    color: '#1e88a8',
                    textAlign: 'center',
                    padding: '18px 0',
                    fontSize: '1.1em',
                    background: '#fff',
                    width: '100%',
                },
            },
        },
        {
            nome: 'campo3',
            placeholder: 'Configurado na Próxima etapa',
            tipo: 'text',
            valor: '',
            estilos: {
                container: {
                    marginBottom: '16px',
                },
                input: {
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    color: '#1e88a8',
                    textAlign: 'center',
                    padding: '18px 0',
                    fontSize: '1.1em',
                    background: '#fff',
                    width: '100%',
                },
            },
        },
        {
            nome: 'campo4',
            placeholder: 'Configurado na Próxima etapa',
            tipo: 'text',
            valor: '',
            estilos: {
                container: {
                    marginBottom: '16px',
                },
                input: {
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    color: '#1e88a8',
                    textAlign: 'center',
                    padding: '18px 0',
                    fontSize: '1.1em',
                    background: '#fff',
                    width: '100%',
                },
            },
        },
    ],
    botao: {
        texto: '',
        estilos: {
            width: '60%',
            height: '44px',
            background: '#149dcc',
            border: 'none',
            borderRadius: '8px',
            margin: '24px auto 0 auto',
            display: 'block',
            color: '#fff',
            fontSize: '1em',
        },
    },
    estilos: {
        container: {
            borderRadius: '8px',
            background: '#fafafa',
            boxShadow: 'none',
            padding: '24px',
        },
    },
});

export const EDITOR_TEXTO_PADRAO = Object.freeze({
    estilos: {
        container: {
            background: '#fff',
            borderRadius: '8px',
            padding: '16px',
        },
        texto: {
            fontSize: '1rem',
            color: '#222',
        },
    },
});

export const GRID_PADRAO = Object.freeze({
    colunas: ['1fr', '1fr'],
    linhas: ['1fr'],
    gap: 8,
    padding: 12,
});
